import {FC} from 'react';
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import {Placement} from "react-bootstrap/types";

interface ButtonEditProps {
    onClick?: any,
    color?: string,
    size?: string,
    tooltipText?: string,
    tooltipPlacement?: Placement
}

const ButtonEdit: FC<ButtonEditProps> = ({
                                             onClick,
                                             color = 'var(--icon)',
                                             size = 'sm',
                                             tooltipText,
                                             tooltipPlacement = 'top'
                                         }) => (
    <span className="ButtonEdit" data-testid="ButtonEdit">
        {tooltipText
            ?
            (
                <OverlayTrigger
                    placement={tooltipPlacement}
                    overlay={
                        <Tooltip>
                            {tooltipText}
                        </Tooltip>
                    }
                >
                    <div role="button" tabIndex={0} onClick={onClick}>
                        <i className={`fas fa-pen-to-square ${size === 'lg' ? 'text-lg' : ''}`} style={{color: color}}/>
                    </div>
                </OverlayTrigger>
            )
            :
            (
                <div role="button" tabIndex={0} onClick={onClick}>
                    <i className={`fas fa-pen-to-square ${size === 'lg' ? 'text-lg' : ''}`} style={{color: color}}/>
                </div>
            )}
    </span>
);

export default ButtonEdit;
